const Video = ({videoUrl}) => {
    return (
        <div
          style={{
           // position: 'relative',
            width: '100%',
           /* height: '100vh',*/
            overflow: 'hidden',
          }}
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              // zIndex: 0,
            }}
            src={videoUrl}
          />
    
          <div
            style={{
              position: 'relative',
              // zIndex: 1,
              color: 'white',
              // padding: '2rem',
              // add any overlay content here
            }}
          >
            {/* Overlay content */}
           
          </div>
        </div>
      );
  };
  
  export default Video;
  